import React, { Component } from 'react';
import { browserHistory } from 'react-router';
// import _ from 'lodash';
import Link from '../../../../../components/ZUILib/Link';
import pdfUtil from '../../../../../utils/PDFUtil';
import commonUtil from '../../../../../utils/commonUtil';
import StatementPrintAndDownload from '../StatementPrintAndDownload';
import { constDownload, constPrint, constSendMail } from '../../../../../utils/clientConstant';
import { sendMail } from '../../actions';
import DownloadPDFWithoutPreview from '../../../../../components/DownloadPDFWithoutPreview';


const applicationRoutes = commonUtil.getApplicationRoutes();

const pageName = 'accountstatus';
export default class BonusDetailPage extends Component {
  constructor(props) {
    super(props);
    this.eventId = this.props.eventId;
    this.state = {
      emailSendStatus: null,
      downloadPrintMailType: null,
    };
  }

  rediectToPage = () => {
    browserHistory.push(commonUtil.routeTo(applicationRoutes.accountStatus, { eventID: this.props.eventId }));
  }
  getStatementDetailsForDownload = () => {
    this.printDownloadMail(constDownload);
  }
  getStatementDetailsForPrint = () => {
    this.printDownloadMail(constPrint);
  }
  getStatementDetailsForSendMail = () => {
    this.printDownloadMail(constSendMail);
  }
  accountStatementSendMail = (fileName, data) => {
    const emailId = !commonUtil.isObjectEmpty(this.props.user) && this.props.user.result && this.props.user.result.emailId;
    sendMail(this.eventId, fileName, data, emailId).then((res) => {
      pdfUtil.contentDownloadedCallback();
      if (res.body.status === 'success') {
        this.setState({ emailSendStatus: { isSent: true, resMsg: commonUtil.getLabel(this.props.lables.eventAccountStatement, 'accountStatement.emailsent.message') } });
      } else {
        this.setState({ emailSendStatus: { isSent: false, resMsg: commonUtil.getLabel(this.props.lables.eventAccountStatement, 'accountStatement.emailfailed.message') } });
      }
    });
  }

  getStatementDetailsForPrintAndDownloadError(data) {
    this.setState({ emailSendStatus: { isSent: false, resMsg: data.error } });
  }

  printDownloadMail = (type) => {
    if (type === constSendMail) {
      const mailContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate} download><StatementPrintAndDownload statementPrintAndDownload={this.props.statementDetailsForPrintAndDownloadData} eventDetailsInfo={this.props.eventInfo} type={this.downloadPrintType} accountStatus={this.props.accountStatus} /></DownloadPDFWithoutPreview>);
      pdfUtil.attachToDomForMail(mailContent, 'accountStatement', this.accountStatementSendMail);
    } else if (type === constDownload) {
      const downloadableContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate} download><StatementPrintAndDownload statementPrintAndDownload={this.props.statementDetailsForPrintAndDownloadData} eventDetailsInfo={this.props.eventInfo} type={this.downloadPrintType} accountStatus={this.props.accountStatus} /></DownloadPDFWithoutPreview>);
      pdfUtil.attachToDom(downloadableContent, ('accountstatus_' + this.eventId));
    } else if (type === constPrint) {
      const printContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate}><StatementPrintAndDownload statementPrintAndDownload={this.props.statementDetailsForPrintAndDownloadData} eventDetailsInfo={this.props.eventInfo} type={this.downloadPrintType} accountStatus={this.props.accountStatus} /></DownloadPDFWithoutPreview>);
      pdfUtil.attachToDomForPrint(printContent, pageName);
    }
  }
  render() {
    const bonusDetailsData = this.props.bonusDetailsData.bonusDetails;
    const physicalInfo = this.props.bonusDetailsData.bonusDetails.physicalItemsBonusInfo;
    const electronicInfo = this.props.bonusDetailsData.bonusDetails.electronicItemsBonusInfo;
    const personalInfo = this.props.bonusDetailsData.bonusDetails.personalItemsBonusInfo;

    let bonusMessage = commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.message1');
    bonusMessage = bonusMessage.replace('{bonus}', bonusDetailsData.bonusPercentage).replace('{amount}',
      commonUtil.getCurrency(bonusDetailsData.totalBonusAmount));

    const DownloadIcon = {
      route: '',
    };
    const RegresarLink = {
      text: 'Regresar',
      children: 'Regresar',
      cssClass: 'lightLink size-Medium',
      onClickHandler: this.rediectToPage,
    };
    const PhysicalGiftPage = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.physicalGifts, { eventID: this.eventId }),
      className: 'lightLink size-Medium',
    };
    const PersonalPage = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.personalPurchases, { eventID: this.eventId }),
      className: 'lightLink size-Medium',
    };
    const electronicGiftsPage = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.electronicsGift, { eventID: this.eventId }),
      className: 'lightLink size-Medium',
    };
    const emailSendLink = {
      cssClass: 'icon-tache2 closeAlert',
      onClickHandler: () => { this.setState({ emailSendStatus: null }); },
    };


    return (
      <div>
        <div className="adminAccountStateContainer">
          <div className="adminContainer">
            <div className="row">
              <div className="col-md-8 barInfoGift">
                <p className="title">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label1')}</p>
              </div>
              <div className="col-md-4">
                <div className="toolsLink text-right">
                  <Link rrLink={DownloadIcon} >
                    <i className="icon-correo" onClick={this.getStatementDetailsForSendMail} aria-hidden="true" />
                  </Link>
                  <Link rrLink={DownloadIcon} >
                    <i className="icon-descarga" onClick={this.getStatementDetailsForDownload} aria-hidden="true" />
                  </Link>
                  <Link rrLink={DownloadIcon} >
                    <i className="icon-imprimir" onClick={this.getStatementDetailsForPrint} aria-hidden="true" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {this.state.emailSendStatus ?
            <React.Fragment>
              {this.state.emailSendStatus.isSent ?
                <div className="alertSuccess" > <i className="icon-check" />
                  <p>{this.state.emailSendStatus.resMsg}</p>
                  <Link linkJSON={emailSendLink} />
                </div> :
                <div className="alertError" > <i className="icon-tache2" />
                  <p>{this.state.emailSendStatus.resMsg}</p>
                  <Link linkJSON={emailSendLink} />
                </div>}
            </React.Fragment> : null}
        </div>
        <div className="adminAccountStateContainer bgGray">
          <div className="adminContainer">
            <div className="row">
              <div className="col-md-12 bonusContainer shadowSquare">
                <div className="row">
                  <div className="col-md-12 subtitle">
                    <p className="title">
                      <i className="iClass icon-ayuda tooltip-container">
                        <span className="tooltip-box dir-left">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.tooltipMessage')}</span>
                      </i>{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label2')}
                    </p>
                  </div>
                  {this.props.eventInfo.isEmployeeEvent ?
                    <div className="col-md-12 infoAditional">
                      <p>{bonusMessage}</p>
                      <p>EL bono estará disponible hasta el cierre de tu mesa.</p>
                    </div>
                    :
                    <div className="col-md-12 infoAditional">
                      <p>{+bonusDetailsData.bonusPercentage}% {commonUtil.getLabel(this.props.lables.eventAccountStatement, 'accountStatement.bonus.message')}.</p>
                      <p>EL bono estará disponible hasta el cierre de tu mesa.</p>
                    </div>}
                </div>
                <div className="row infoGiftsBonus">
                  <div className="col-md-12">
                    <p className="title">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label4')}:</p>
                    <p className="seeDetail">
                      <Link rrLink={PhysicalGiftPage}>
                        <span>Ver detalle &nbsp;<i className="icon-flecha_gruesa_derecha" aria-hidden="true" /></span>
                      </Link>
                    </p>
                  </div>
                  <div className="col-md-12 inlineSectionBonus">
                    <p>{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label5')}:</p>
                    <p>{commonUtil.getCurrency(physicalInfo.totalBonusEligibleAmont)}</p>
                  </div>
                  <div className="col-md-12 inlineSectionBonus novalidate">
                    <p>{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label6')}:</p>
                    <p>{commonUtil.getCurrency(physicalInfo.totalAmountNotEligibleForBonus)}</p>
                  </div>
                  <div className="col-md-12 bonusInfo inlineSectionBonus bonusTotal">
                    <p>{+bonusDetailsData.bonusPercentage}% {commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label7')}:</p>
                    <p>{commonUtil.getCurrency(physicalInfo.totalBonusAccumulated)}</p>
                  </div>
                </div>
                <div className="row infoGiftsBonus">
                  <div className="col-md-12">
                    <p className="title">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label8')}:</p>
                    <p className="seeDetail">
                      <Link rrLink={PersonalPage}>
                        <span>Ver detalle &nbsp;<i className="icon-flecha_gruesa_derecha" aria-hidden="true" /></span>
                      </Link>
                    </p>
                  </div>
                  <div className="col-md-12 inlineSectionBonus">
                    <p>{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label9')}:</p>
                    <p>{commonUtil.getCurrency(personalInfo.totalBonusEligibleAmont)}</p>
                  </div>
                  <div className="col-md-12 inlineSectionBonus novalidate">
                    <p>{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label10')}:</p>
                    <p>{commonUtil.getCurrency(personalInfo.totalAmountNotEligibleForBonus)}</p>
                  </div>
                  <div className="col-md-12 bonusInfo inlineSectionBonus bonusTotal">
                    <p>{+bonusDetailsData.bonusPercentage}% {commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label11')}:</p>
                    <p>{commonUtil.getCurrency(personalInfo.totalBonusAccumulated)}</p>
                  </div>
                </div>
                <div className="row infoGiftsBonus">
                  <div className="col-md-12">
                    <p className="title">{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label12')}:</p>
                    <p className="seeDetail">
                      <Link rrLink={electronicGiftsPage}>
                        <span>Ver detalle &nbsp;<i className="icon-flecha_gruesa_derecha" aria-hidden="true" /></span>
                      </Link>
                    </p>
                  </div>
                  <div className="col-md-12 inlineSectionBonus">
                    <p>{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label13')}</p>
                    <p>{commonUtil.getCurrency(electronicInfo.totalBonusEligibleAmont)}</p>
                  </div>
                  <div className="col-md-12 bonusInfo inlineSectionBonus bonusTotal">
                    <p>{+bonusDetailsData.bonusPercentage}% {commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label14')}:</p>
                    <p>{commonUtil.getCurrency(electronicInfo.totalBonusAccumulated)}</p>
                  </div>
                </div>
                <div className="row infoGiftsBonus">
                  <div className="col-md-12 bonusInfo inlineSectionBonus rodeTotal">
                    <p>{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label15')}:</p>
                    <p>{commonUtil.getCurrency(bonusDetailsData.totalBonusEligibleAmount)}</p>
                  </div>
                </div>
                <div className="row infoGiftsBonus">
                  <div className="col-md-12 bonusInfo inlineSectionBonus aproximateRodeTotal">
                    <p>{commonUtil.getLabel(this.props.lables['Bonus Details Page'], 'accountStatement.bonusDetail.label16')}:</p>
                    <p>{commonUtil.getCurrency(bonusDetailsData.totalBonusAmount)}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="adminContainer footerActions">
            <div className="row">
              <Link linkJSON={RegresarLink} ><i className="iconLeft icon-flecha_light_izq" />Regresar</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
